import { useEffect, useState } from 'react';

const HERO_IMAGE = import.meta.env.VITE_HOME_HERO_IMAGE || '/media/home-hero.jpg';

/**
 * Фон главной (`/:translation/home`): фото воды на рассвете, «живое» за счёт CSS —
 * медленный дрейф кадра и блики света. Файл: front/public/media/home-hero.jpg
 */
export default function BfHomeBackdrop() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const img = new Image();
    img.decoding = 'async';
    img.onload = () => {
      if (!cancelled) setReady(true);
    };
    img.src = HERO_IMAGE;
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div
      className={`bf-home-cinema${ready ? ' bf-home-cinema--ready' : ''}`}
      style={{ '--bf-home-hero': `url("${HERO_IMAGE}")` }}
      aria-hidden="true"
    >
      <div className="bf-home-cinema__ambient" />
      <div className="bf-home-cinema__photo" />
      <div className="bf-home-cinema__glint" />
      <div className="bf-home-cinema__shade" />
      <div className="bf-home-cinema__grain" />
    </div>
  );
}
